<template>
  <div :class="classes" class="shop-buttons py-2">
    <h2 v-if="title" class="title">{{title}}</h2>
    <div class="d-flex align-items-center content-container">
      <jet-button @click="linkClicked" icon="fas fa-long-arrow-alt-left">Shop</jet-button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    args: Object,
    link: String,
    classes: [String, Array],
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    linkClicked() {
      const baseUrl = this.$page.props.flash.prev_url.split('?')[0]
      
      // They came back from the correct shop
      if (this.link.includes(baseUrl)) window.history.back()

      // They came from a different page
      else this.$inertia.visit(this.link)
    }
  }
}
</script>

<style>
  .shop-buttons {
    display: flex;
    justify-content: space-between;
  }
</style>
